
/**
 * - Please ensure to provide label for the checkbox either by passing a `label` prop or as a slot
 * - To toggle custom values, instead of the default `true` / `false`, specify `trueValue` and `falseValue` properties
 * - The component can be used in two modes:
 *  - Single checkbox: To toggle a primitive value (for example `true` => `false`)
 *  - Group of checkboxes sharing common `v-model`: To add or remove an item from an array value (for example `['apple']` => `['apple', 'orange']`)
 **/

export default {
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    /**
     * Prop used by the v-model binding
     */
    modelValue: {
      type: [Array, Boolean, Number, String],
      default: ""
    },
    label: {
      type: String,
      default: null
    },
    inputId: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    /**
     * Values to use for the model, instead of the default `true` / `false`
     * Relevant when checkbox is not part of a group (`modelValue` is a primitive value)
     */
    trueValue: {
      type: [Boolean, Number, String],
      default: true
    },
    falseValue: {
      type: [Boolean, Number, String],
      default: false
    },
    /**
     * Value to add or remove from the model array
     * Relevant only when checkbox is part of a group (`modelValue` is an array)
     */
    value: {
      type: [Boolean, Number, String, Object],
      default: ""
    },
    hasError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    checkboxCard: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    binding: {
      get() {
        return this.modelValue
      },
      set(isChecked) {
        this.$emit("change", isChecked)
      }
    }
  }
}
